<script setup lang="ts">

import type { HTMLAttributes } from 'vue';

defineProps<{
  name: string,
  logo?: string | null,
  class?: HTMLAttributes['class'],
}>();
</script>
<template>
  <img
    v-if="logo"
    :class="['max-w-full w-auto', $props.class]"
    :src="logo"
    :alt="`School ${name} logo`"
  >
  <div
    v-else
    :class="[
      'flex items-center truncate text-sm font-medium text-(--color-sidebar-menu-text)',
      $props.class,
    ]"
  >
    {{ name }}
  </div>
</template>
